const pad = (n) => String(n).padStart(2, "0");

export const brl = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const fmtDate = (s) => (s ? `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)}` : "—");
export const fmtShort = (s) => (s ? `${s.slice(8, 10)}/${s.slice(5, 7)}` : "—");
export const toISO = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const parseISO = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};
export const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};
export const startOfWeek = (d) => addDays(d, -((d.getDay() + 6) % 7));
export const todayISO = () => toISO(new Date());
export const weekdayName = (s) => WEEKDAYS_LONG[(parseISO(s).getDay() + 6) % 7];

export const WEEKDAYS_SHORT = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];
export const WEEKDAYS_LONG = ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"];
export const MONTHS = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

export const CLASS_STATUS = { agendada: "Agendada", confirmada: "Confirmada", realizada: "Realizada", cancelada: "Cancelada", faltou: "Aluno faltou" };
export const PAYMENT_STATUS = { pago: "Pago", pendente: "Pendente", atrasado: "Atrasado", cancelado: "Cancelado" };
export const METHODS = { pix: "Pix", dinheiro: "Dinheiro", cartao: "Cartão", transferencia: "Transferência", outro: "Outro" };
export const BILLING = { por_aula: "Por aula", pacote: "Pacote de aulas", mensalidade: "Mensalidade" };
export const KINDS = { aula: "Aula", pacote: "Pacote", mensalidade: "Mensalidade", avulso: "Avulso" };
export const MODALITY = { presencial: "Presencial", online: "Online", ambas: "Presencial e online" };

export const nullify = (obj) => Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, v === "" ? null : v]));
export const initials = (name = "") => name.split(" ").filter(Boolean).slice(0, 2).map((p) => p[0]).join("").toUpperCase();
export const endTime = (start, duration) => {
  const [h, m] = start.split(":").map(Number);
  const t = h * 60 + m + duration;
  return `${pad(Math.floor(t / 60) % 24)}:${pad(t % 60)}`;
};
